import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const gymEndPoints = {
  GET_IPA: 'iesv/api/v1/ipa/lessons',
  GET_IPA_OPEN: 'iesv/api/v1/open/ipa/lessons',
  SPEECH_CHECK: 'iesv/api/v1/check/speech',
  GET_STATISTICS: 'iesv/api/v1/ipa/users/statistics',
  SEND_DETAILS_RESULTS: 'iesv/api/v1/ipa/lessons/details/results',
}

const gymRequest = {
  getGymResult: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${gymEndPoints.GET_IPA}`, {})
    }
    return apiGlobal.get(`${gymEndPoints.GET_IPA_OPEN}`, {})
  },
  getGymLessonResult: ({lessonId, type}: {lessonId: any; type: any}) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${gymEndPoints.GET_IPA}/${lessonId}/types/${type}`,
        {},
      )
    }
    return apiGlobal.get(
      `${gymEndPoints.GET_IPA}/${lessonId}/types/${type}`,
      {},
    )
  },
  getSpeechCheck: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(gymEndPoints.SPEECH_CHECK, params, {}, true)
    }
    return apiGlobal.post(gymEndPoints.SPEECH_CHECK, params, {}, true)
  },
  getStatistics: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${gymEndPoints.GET_STATISTICS}`, {})
    }
    return apiGlobal.get(`${gymEndPoints.GET_STATISTICS}`, {})
  },
  sendDetailsResults: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(gymEndPoints.SEND_DETAILS_RESULTS, params, {})
    }
    return apiGlobal.post(gymEndPoints.SEND_DETAILS_RESULTS, params, {})
  },
}

export default gymRequest
